export const GROUP_GIFT_HELP_REDIRECTION_LINK = 'https://withjoy.com/help/en/articles/9714104-group-gifting-and-how-does-it-work';
